var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToparrowPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.42187 16.5C5.42187 16.9142 5.75766 17.25 6.17187 17.25C6.58609 17.25 6.92187 16.9142 6.92188 16.5L5.42187 16.5ZM6.70221 0.812822C6.40932 0.519929 5.93444 0.519929 5.64155 0.812821L0.868577 5.58579C0.575684 5.87868 0.575684 6.35356 0.868577 6.64645C1.16147 6.93934 1.63634 6.93934 1.92924 6.64645L6.17188 2.40381L10.4145 6.64645C10.7074 6.93935 11.1823 6.93935 11.4752 6.64645C11.7681 6.35356 11.7681 5.87869 11.4752 5.58579L6.70221 0.812822ZM6.92188 16.5L6.92188 1.34315L5.42188 1.34315L5.42187 16.5L6.92188 16.5Z",
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToparrowPink);
export default __webpack_public_path__ + "static/media/toparrowPink.5d8646bd1bd28db28f943abc864a29b2.svg";
export { ForwardRef as ReactComponent };